// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1JLj1","rootCenter":"LoadMoreObserver_rootCenter__21icY","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2yJAF"};